import React, { memo } from 'react';
import { BaseGlobalSearchLink } from 'site-modules/shared/components/inventory/global-search/global-search-links/base-global-search-link';
import { PersonalizedSearchLinkIcon } from 'site-modules/shared/components/inventory/global-search/global-search-links/personalized-search-link/personalized-search-link-icon';
import { PersonalizedSearchLinkTitle } from 'site-modules/shared/components/inventory/global-search/global-search-links/personalized-search-link/personalized-search-link-title';
import {
  GlobalSearchLinkDefaultProps,
  GlobalSearchLinkPropTypes,
} from 'site-modules/shared/constants/global-search/global-search-prop-types';

export const PersonalizedSearchLink = memo(
  ({
    query = GlobalSearchLinkDefaultProps.query,
    creativeId = GlobalSearchLinkDefaultProps.creativeId,
    isMobile = GlobalSearchLinkDefaultProps.isMobile,
    onLinkClick = GlobalSearchLinkDefaultProps.onLinkClick,
    url = GlobalSearchLinkDefaultProps.url,
    selectionType = GlobalSearchLinkDefaultProps.selectionType,
    title = GlobalSearchLinkDefaultProps.title,
    fastMatcherData = GlobalSearchLinkDefaultProps.fastMatcherData,
    icon = GlobalSearchLinkDefaultProps.icon,
    label = GlobalSearchLinkDefaultProps.label,
    linkType = GlobalSearchLinkDefaultProps.linkType,
    ...restProps
  }) => {
    return (
      <BaseGlobalSearchLink
        {...restProps}
        query={query}
        creativeId={creativeId}
        isMobile={isMobile}
        onLinkClick={onLinkClick}
        url={url}
        selectionType={selectionType}
        title={title}
        fastMatcherData={fastMatcherData}
        icon={icon}
        label={label}
        linkType={linkType}
        linkThumbComponent={PersonalizedSearchLinkIcon}
        linkTitleComponent={PersonalizedSearchLinkTitle}
        rel="nofollow"
      />
    );
  }
);

PersonalizedSearchLink.displayName = 'PersonalizedSearchLink';

PersonalizedSearchLink.propTypes = {
  ...GlobalSearchLinkPropTypes,
};
